<template>
  <v-container class="pa-0" style="width: auto; height: auto">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-if="!$store.state.teacherAccess"
          style="width: auto; height: auto"
          v-bind="attrs"
          v-on="on"
          @click="layout = true"
        >
          <my-icon
            :name="'setting-icon'"
            :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </v-btn>
      </template>
      <span>{{ $t("template-setting") }}</span>
    </v-tooltip>

    <v-dialog
      v-model="layout"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
      :width="isMobile ? undefined : 820"
    >
      <div class="tsd" :class="{ 'tsd--mobile': isMobile }">
        <header class="tsd__head">
          <span class="tsd__head-icon"><v-icon>mdi-palette-swatch-outline</v-icon></span>
          <div class="tsd__head-text">
            <div class="tsd__title">{{ $t("themeSettingsTitle") }}</div>
            <div class="tsd__sub">{{ $t("themeSettingsSub") }}</div>
          </div>
          <v-spacer />
          <button type="button" class="tsd__close" :aria-label="$t('close')" @click="layout = false">
            <v-icon>mdi-close</v-icon>
          </button>
        </header>
        <div class="tsd__body">
          <theme-settings :wide="!isMobile" />
        </div>
        <footer v-if="isMobile" class="tsd__foot">
          <button type="button" class="tsd__done" @click="layout = false">{{ $t("close") }}</button>
        </footer>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
// Redesigned copy of appbar/partial/TemplateSetting.vue (original untouched):
// same gear button, new dialog shell around ThemeSettings.
import ThemeSettings from "./ThemeSettings.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "ThemeSettingsButton",
  components: {
    ThemeSettings,
    MyIcon,
  },
  data() {
    return {
      layout: false,
    };
  },
};
</script>

<style scoped>
.tsd {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}
.theme--dark .tsd {
  background: #1e1e1e;
}
.tsd--mobile {
  height: 100%;
  max-height: none;
  border-radius: 0;
}
.tsd__head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #eef0f4;
}
.theme--dark .tsd__head {
  border-color: #333;
}
.tsd__head-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 102, 255, 0.1);
}
.tsd__head-icon .v-icon {
  color: var(--v-primary-base, #0066ff) !important;
}
.tsd__title {
  font-weight: 700;
}
.tsd__sub {
  font-size: 0.74rem;
  color: #8a94a6;
}
.tsd__close {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.tsd__close:hover {
  background: rgba(0, 0, 0, 0.06);
}
.tsd__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 18px 18px;
}
.tsd__foot {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #eef0f4;
}
.theme--dark .tsd__foot {
  border-color: #333;
}
.tsd__done {
  height: 38px;
  min-width: 96px;
  padding: 0 18px;
  border-radius: 6px;
  border: 1px solid #dfe3ea;
  font-size: 0.88rem;
  color: #374151;
  background: #fff;
}
.tsd__done:hover {
  border-color: #b8c0cc;
}
.theme--dark .tsd__done {
  background: #1e1e1e;
  border-color: #3a3a3a;
  color: #ddd;
}
</style>
